// extracted by mini-css-extract-plugin
export default {"checkboxCursorDefault":"style_checkboxCursorDefault__AVyhh"};